import { render, staticRenderFns } from "./SpreadSelector.vue?vue&type=template&id=b52a33fa"
import script from "./SpreadSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpreadSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports